// RadioButtonGroup.js
import React from "react";

const RadioButtonGroup = ({ label, options, selectedValue, onChange }) => (
  <div>
    <label className="block text-sm font-medium mb-2">{label}</label>
    <div className="flex space-x-4">
      {options.map((option, index) => (
        <label key={index}>
          <input
            type="radio"
            name={label}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          {option.label}
        </label>
      ))}
    </div>
  </div>
);

export default RadioButtonGroup;
